import { Link } from '@umijs/max';
import type { BreadcrumbProps } from 'antd';

const getRoutePath = (route: { path?: string; linkPath?: string }) =>
  route.path ?? route.linkPath;

/** 面包屑第一项不可点击，其余项正常跳转 */
export const breadcrumbItemRender: BreadcrumbProps['itemRender'] = (
  route,
  _params,
  routes,
) => {
  const currentPath = getRoutePath(route);
  const routeIndex = routes.findIndex(
    (item) => getRoutePath(item) === currentPath,
  );
  const isFirst = routeIndex === 0;
  const title =
    route.title ?? (route as { breadcrumbName?: string }).breadcrumbName;

  if (isFirst) {
    return <span>{title}</span>;
  }

  if (currentPath) {
    return <Link to={currentPath}>{title}</Link>;
  }

  return <span>{title}</span>;
};
